/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_tp.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions TP */
HafasWebapp.prototype.subscriptions.tp = function (_me) {
  Hafas.ps.sub('/tp/switchFromTo', Hafas.bind(function () {
    var controller = _me.Controller.TP;
    // get current input texts (no locations)
    var inputTextFrom = controller.inpFrom.getInputText();
    var inputTextTo = controller.inpTo.getInputText();

    // try to switch real valid locations based on tp module -> changes input text of suggests with pub/sub event
    controller.instance.switchLocations();

    // Locations have been switched in the data, also switch the information in the suggest instances to match the query data
    var instanceQueryData = controller.instance.data.query;
    var depLoc = instanceQueryData.depLocL[0];
    var arrLoc = instanceQueryData.arrLocL[0];
    if (depLoc) {
      controller.inpFrom.setLocation(depLoc);
    }
    if (arrLoc) {
      controller.inpTo.setLocation(arrLoc);
    }

    // Switching is done, trigger via updates
    Hafas.bind(controller.options.get, controller.options)(); // trigger update of the model in the options module to set the duration // taken from confirmDurationForVia
    Hafas.bind(controller.updateViaFieldVisibility, this)(false);

    if (Hafas.Config.Switches.useEuSpirit === true) {
      // additional switch region settings for euspirit
      controller.switchEuSpiritRegions.bind(this)();
    }

    // is everything switched correctly - are both locations set in tp module?
    if (!depLoc || !arrLoc) {
      // no, then try to switch the input text of suggests
      if (!arrLoc && inputTextFrom) controller.inpTo.setInputText(inputTextFrom);
      if (!depLoc && inputTextTo) controller.inpFrom.setInputText(inputTextTo);
    } else if (controller.currentView === 'overview') {
      // yes, trigger search for unified planner
      Hafas.ps.pub("/tp/events/trigger/unified");
    }

    Hafas.ps.pub('/tracking/event/journey-planner-switch-directions', [{
      typ: 'event',
      key: 'journey-planner-switch-directions'
    }]);
    Hafas.ps.pub('/tracking/event/tripplanner-switchdirections-pressed', [{
      typ: 'event',
      key: 'tripplanner-switchdirections-pressed'
    }]);
  }, _me));


  Hafas.ps.sub('/tp/favorites/showPopover', Hafas.bind(_me.Controller.TP.showLocationSelectionPopover,_me));
  Hafas.ps.sub('/tp/favorites/showDefaultFavoritePopover', Hafas.bind(_me.Controller.TP.showDefaultQuickFavoritePopover,_me));
  Hafas.ps.sub('/tp/favorites/closeLocationPopover', Hafas.bind(_me.Controller.TP.hideLocationSelectionPopover, _me));
  Hafas.ps.sub('/favorites/closeLocationPopover', Hafas.bind(_me.Controller.TP.hideLocationSelectionPopover, _me));

  Hafas.ps.sub('/tp/favorites/connectionsHistory/showPopover', Hafas.bind(_me.Controller.TP.showConnectionsHistoryPopover,_me));
  Hafas.ps.sub('/tp/favorites/connectionsHistory/closePopover', Hafas.bind(_me.Controller.TP.hideConnectionsHistoryPopover, _me));

  Hafas.ps.sub('/map/select', Hafas.bind(function (type, locKey) {
    // Hide edit smartLocation view if opened and show form
    Hafas.ps.pub('/favorites/smartLocations/closeView');
    Hafas.ps.pub('/GUI/form/show', [{}]);

    // Da bei SQ-Direkteinsprung TP zuvor nie geladen wurde, ggf. nachholen bevor mit dem TP-Controller gearbeitet wird
    Hafas.Modules.Loader.loadTemplateFiles([
      'tp.index.html'
    ], Hafas.bind(function () {
      var location = Hafas.Modules.Render.objectKeeper.get(locKey);
      var $detailsHeader = Hafas('#TP_ResultDetail .lyr_atomActionbarWrapper', false);
      if ($detailsHeader) {
        Hafas.ps.pub('/app/events/closeResults', [{
          appcontext: 'TP',
          resultSet: 'detail',
          ev: {
            preventDefault: function () {
            }
          }
        }]);
      }

      if (_me.appContext === 'TP') {
        if (Hafas.Config.TP.unifiedPlanner.show == false) {
          Hafas.ps.pub('/app/events/closeResults', [{
            appcontext: 'TP',
            resultSet: 'overview',
            ev: {
              preventDefault: function () {
              }
            }
          }]);
        }
      }

      if (Hafas.Config.TP.unifiedPlanner.show == false || this.layoutClass == 'small') {
        Hafas.ps.pub('/GUI/map/hide', []);
      }


      _me.Controller.TP.instance.setLocation(type, location);

      if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest) {
        _me.Controller.Favorites.instance.addLocation(location, 'History');
      }

      if (Hafas.Config.TP.unifiedPlanner.show == false) {
        Hafas.bind(_me.Controller.TP.renderIndex, _me)();
      } else {
        if(_me.Controller.TP.currentView === 'overview' || _me.Controller.TP.currentView === 'details') {
          Hafas.ps.pub('/tp/postForm', [{form: Hafas('#HFS_FormTripSearch')}]);
        }
        Hafas.ps.pub('/app/events/resize', []);
      }

      // Focus menu button
      Hafas.Util.gui.focusFirstElement('#HFS_PageContent');

      // Tracking
      if (type === 'dep') Hafas.ps.pub('/tracking/event/mapflyout-start-pressed', [{
        typ: 'event',
        key: 'mapflyout-start-pressed'
      }]);
      if (type === 'arr') Hafas.ps.pub('/tracking/event/mapflyout-destination-pressed', [{
        typ: 'event',
        key: 'mapflyout-destination-pressed'
      }]);

      Hafas.ps.pub('/GUI/common/pageContentToggle',[{trigger: 'sub'}]);
      Hafas.ps.pub('/GUI/common/highlightingInput',[{type:type}])
    }, this));
  }, _me));

  Hafas.ps.sub('/tp/selectLocation', Hafas.bind(_me.Controller.TP.setLocation, _me));

  // Geolocation Aktivierung
  Hafas.ps.sub('/common/currentPositionActivated/From', Hafas.bind(_me.Controller.TP.setGeoLocationPosition, _me));
  Hafas.ps.sub('/common/currentPositionActivated/To', Hafas.bind(_me.Controller.TP.setGeoLocationPosition, _me));

  // Setzte Datum und Zeit
  Hafas.ps.sub('/tp/setDate', Hafas.bind(_me.Controller.TP.setDate, _me));
  Hafas.ps.sub('/tp/setTime', Hafas.bind(_me.Controller.TP.setTime, _me));
  Hafas.ps.sub('/tp/setEnquiry', Hafas.bind(_me.Controller.TP.setEnquiry, _me));

  /* Zeitvalidierung beim Verlassen des Zeitfeldes */
  Hafas.ps.sub('/tp/validateTime', Hafas.bind(function (inputField) {
    var timeInput = inputField.value;
    var inputType = inputField.type;
    var timeValidation = Hafas.Core.newType("hafasTimeValidation", timeInput);
    var inputFieldValueLength = inputField.value.length;
    var viaIndex = inputField.getAttribute("data-hci-viaDuration");
    var validatedValue;

    // Reset error class
    inputField.classList.remove('js_highLightingError');

    // Reset via duration on empty input
    if (viaIndex != null && inputFieldValueLength === 0) {
      inputField.value = '';
      _me.Controller.TP.instance.setVia({dur: inputField.value, min: 0}, viaIndex);
      return; // Skip validation and highlighting
    }

    // Validate
    if (viaIndex != null) {
      inputType = "duration";
      validatedValue = timeValidation.validate({type: 'hciDuration', getNullOnError: true});
    } else {
      validatedValue = timeValidation.validate();
    }

    if (validatedValue != null) {
      // Format and fill in text
      if (inputType === "time") {
        inputField.value = validatedValue.getNativeTimeFormat();
      } else if (inputType === "duration") {
        var viaId = inputField.getAttribute("data-via-id");
        var viaOption = _me.Controller.TP.options.getModelById({id: viaId});
        inputField.value = validatedValue.format(viaOption.viaDurationOfStay.timeInputFormat);
      } else {
        inputField.value = validatedValue.format(Hafas.Config.timeOutputFormat);
      }

      // Set time in model
      if (viaIndex != null) {
        var durationHoursInMinutes = validatedValue.getJsDate().getHours() * 60;
        var durationMinutes = validatedValue.getJsDate().getMinutes();
        var duration = durationHoursInMinutes + durationMinutes;
        _me.Controller.TP.instance.setVia({dur: inputField.value, min: duration}, viaIndex);
      } else {
        _me.Controller.TP.instance.setOutTime(validatedValue.getHCITime());
      }
    } else {
      // Error, highlight input field by class
      Hafas.ps.pub('/GUI/common/highlightingInput', [{
        type: 'element',
        element: inputField,
        className: 'js_highLightingError',
        keepClass: true
      }]);
    }
  }, _me));

  Hafas.ps.sub('/tp/setVia', Hafas.bind(_me.Controller.TP.setVia,_me));
  Hafas.ps.sub('/tp/setViaFromExternal', Hafas.bind(function(type,objKeepRef){
      if(_me.Controller.TP.instance.getViaCount() < Hafas.Config.TP.vias.amount){
         // Kontext wechseln, wenn man sich noch nicht im Routenplaner befindet
         if (_me.appContext != 'TP') {
           Hafas.ps.pub('/app/switchContext', [{context: 'TP', method: 'index'}]);
         }

        // Hide old results from search without new via
        if (_me.Controller.TP.currentView === 'details') {
          Hafas.ps.pub('/app/events/closeResults', [{
            appcontext: 'TP',
            resultSet: 'detail',
            ev: {
              preventDefault: function () {
              }
            }
          }]);
        } else if (_me.Controller.TP.currentView === 'overview' && Hafas.Config.TP.unifiedPlanner.show === false) {
          Hafas.ps.pub('/app/events/closeResults', [{
            appcontext: 'TP',
            resultSet: 'overview',
            ev: {
              preventDefault: function () {
              }
            }
          }]);
        }

         // Via Form einblenden, wenn Vias zwischen Start & Ziel angezeigten werden
         if(Hafas.Config.TP.vias.showInForm && !_me.Controller.TP.viasOpen){
           _me.Controller.TP.showViaForm.bind(_me)();
         }

         if (Hafas.Config.TP.unifiedPlanner.show == false || _me.layoutClass == 'small') {
            Hafas.ps.pub('/GUI/map/hide', []);
         }

         // Via einfügen und Feld highlighten
         var viaIndex = _me.Controller.TP.instance.getAvailableViaIndex();
         var location = Hafas.Modules.Render.objectKeeper.get(objKeepRef)
         var highlightingParams = {type:'via', viaIndex: viaIndex};
         Hafas.ps.pub('/GUI/common/highlightingInput',[highlightingParams]);
         Hafas.ps.pub('/tp/setVia',[viaIndex,location]);

         Hafas.ps.pub('/GUI/common/pageContentToggle',[{trigger: 'sub'}]);

        if (Hafas.Config.TP.unifiedPlanner.show === false) {
          // If form is not shown in result overview, show form ...
          // ... but load template files first for calls from other contexts (e.g. TariffWizard)
          Hafas.Modules.Loader.loadTemplateFiles(['tp.index.html', 'common.options.html'], Hafas.bind(function () {
            Hafas.bind(_me.Controller.TP.renderIndex, _me)();
          }, _me));
        } else {
          // Trigger search
          if (_me.Controller.TP.currentView === 'overview' || _me.Controller.TP.currentView === 'details') {
            Hafas.ps.pub('/tp/events/trigger/unified');
          }
          Hafas.ps.pub('/app/events/resize', []);
        }

        // Flyout schließen
        _me.Controller.Map.closeToolbox.bind(_me)();

        // Focus menu button
        Hafas.Util.gui.focusFirstElement('#HFS_PageContent');
      }else{
        _me.Controller.TP.showViaInfoPopup.bind(_me)();
      }
  },_me));

  Hafas.ps.sub('/tp/switchLocationsDone', Hafas.bind(_me.Controller.TP.updateVias,_me));

  Hafas.ps.sub('/tp/postForm', Hafas.bind(_me.Controller.TP.postForm, _me));
  Hafas.ps.sub("/tp/toggleDetails", Hafas.bind(_me.Controller.TP.toggleDetails, _me));
  Hafas.ps.sub("/tp/expandConnectionsByElementId", Hafas.bind(_me.Controller.TP.expandConnectionsByElementId, _me));

  Hafas.ps.sub("/tp/redrawSelectedConnection", Hafas.bind(_me.Controller.TP.redrawSelectedConnection, _me));

  // Funktionalität für Favoriten-Stern in der Verbindungsübersicht
  Hafas.ps.sub('/tp/toggleConnectionFavorite', Hafas.bind(_me.Controller.TP.toggleConnectionFavorite, _me));
  Hafas.ps.sub('/tp/checkConnectionFavorite', Hafas.bind(_me.Controller.TP.checkConnectionFavorite, _me));

  // Blättern rückwarts
  Hafas.ps.sub('/tp/earlierConnections', Hafas.bind(function (data) {
    Hafas.ps.pub('/tracking/event/tripplanner-overview-earlier-pressed', [{
      typ: 'event',
      key: 'tripplanner-overview-earlier-pressed'
    }]);
    Hafas.bind(_me.Controller.GUI.results.overview.showEarlierLaterFirstLastLoader, _me)(data);
    _me.Controller.TP.instance.searchBack({
      ptCallback: function (data) {Hafas.bind(_me.Controller.TP.showResultOverview, _me)(data, {scrollToTop:true})},
      ivCallback: function (data) {Hafas.bind(_me.Controller.TP.showIVResultOverview, _me)(data, {scrollToTop:true})},
      group: data.grpid
    });
  }, _me));
  // Blättern vorwärts
  Hafas.ps.sub('/tp/laterConnections', Hafas.bind(function (data) {
    Hafas.ps.pub('/tracking/event/tripplanner-overview-later-pressed', [{
      typ: 'event',
      key: 'tripplanner-overview-later-pressed'
    }]);
    Hafas.bind(_me.Controller.GUI.results.overview.showEarlierLaterFirstLastLoader, _me)(data);
    _me.Controller.TP.instance.searchForward({
      ptCallback: Hafas.bind(_me.Controller.TP.showResultOverview, _me),
      ivCallback: Hafas.bind(_me.Controller.TP.showIVResultOverview, _me),
      group: data.grpid
    });
  }, _me));
  Hafas.ps.sub('/tp/earlierLaterConnectionFound', Hafas.bind(function (data) {
    Hafas.bind(_me.Controller.GUI.results.overview.hideEarlierLaterFirstLastLoader, _me)(data);
  }, _me));
  // Erste Fahrt
  Hafas.ps.sub('/tp/firstConnection', Hafas.bind(function (data) {
    Hafas.bind(_me.Controller.GUI.results.overview.showEarlierLaterFirstLastLoader, _me)(data);
    Hafas.bind(_me.Controller.GUI.results.overview.disableFirstLastLink, _me)(data.trigger);
    _me.Controller.TP.instance.searchFirst({
      ptCallback: function (data) {Hafas.bind(_me.Controller.TP.showResultOverview, _me)(data, {scrollToTop:true})},
      ivCallback: function (data) {Hafas.bind(_me.Controller.TP.showIVResultOverview, _me)(data, {scrollToTop:true})},
      group: data.grpid
    });
  }, _me));
  // Letzte Fahrt
  Hafas.ps.sub('/tp/lastConnection', Hafas.bind(function (data) {
    Hafas.bind(_me.Controller.GUI.results.overview.showEarlierLaterFirstLastLoader, _me)(data);
    Hafas.bind(_me.Controller.GUI.results.overview.disableFirstLastLink, _me)(data.trigger);
    _me.Controller.TP.instance.searchLast({
      ptCallback: Hafas.bind(_me.Controller.TP.showResultOverview, _me),
      ivCallback: Hafas.bind(_me.Controller.TP.showIVResultOverview, _me),
      group: data.grpid
    });
  }, _me));
  Hafas.ps.sub('/tp/firstLastConnectionFound', Hafas.bind(function (data, grpId) {
    Hafas.bind(_me.Controller.GUI.results.overview.hideFirstLastLink, _me)(data, grpId);
  }, _me));

  // Auswahl Produkt für Fahrplanauskunft
  Hafas.ps.sub("/tp/selectProduct", Hafas.bind(function (pCls, boolval) {
    Hafas.ps.pub('/tp/options/activateLocalStorage', [true]);
    _me.Controller.TP.instance.setProductClass(parseInt(pCls), boolval);
    _me.Controller.TP.options.setProduct(pCls, boolval);
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
  }, _me));

  // Vorbelegung Start/Ziel
  Hafas.ps.sub('/tp/setLocationValue/webapp', Hafas.bind(function (type, location) {
    var locationName = '';
    if (location != null) {
      locationName = Hafas.Util.getLocationAttribute(location, "name");
    }

    var input = null;
    var suggestInstance = null;

    if (_me.appContext === 'TP') {
      if (type == "dep") {
        input = Hafas('#From', false);
        suggestInstance = _me.Controller.TP.inpFrom;
      } else if (type == "arr") {
        input = Hafas('#To', false);
        suggestInstance = _me.Controller.TP.inpTo;
      } else if (type == "via") {
        input = Hafas('#Via', false);
      }
    }

    // only set value if it's different to the current one
    if (input != null && input.value !== locationName) {
      input.value = locationName;

      if (locationName) {
        // find matching label for screenreader announcement
        var label = (Hafas('label[for="' + input.id + '"]') || {});
        Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
          element: (label.textContent || Hafas.Modules.i18n.get('common.label.t_N_Unknown')),
          text: locationName
        }));
      }
    }

    // Remove Push highlighting if input is filled in
    Hafas.ps.pub('/GUI/common/removeHighlightingFromInput',[{type: 'element', element: input, className: 'js_highLightingGlow'}]);

    if (_me.appContext !== 'TP') {
      Hafas.ps.pub('/app/switchContext', [{context: 'TP', method: 'index'}]);
    }
    // Store the Input value in Session
    if(suggestInstance){
      suggestInstance.setInputInStorage();
    }
  }, _me));

  // Update GUI when setting the location
  Hafas.ps.sub('/tp/setLocation/webapp', Hafas.bind(function (type, location) {
    Hafas.ps.pub('/tp/setLocationValue/webapp', [type, location]);
  }, _me));

  // Set a query parameter that can't be set through the options model
  Hafas.ps.sub('/tp/setQueryParameter', Hafas.bind(_me.Controller.TP.setQueryParameter, _me));

  Hafas.ps.sub('/tp/removeVia', Hafas.bind(_me.Controller.TP.removeVia,_me));
  Hafas.ps.sub("/tp/cancelDragDrop", Hafas.bind(_me.Controller.TP.cancelDragDrop, _me));
  Hafas.ps.sub('/tp/deleteViaCtxMenu', Hafas.bind(_me.Controller.TP.deleteViaCtxMenu,_me));

  Hafas.ps.sub('/tp/closeConfirmViaDurationPopover', Hafas.bind(_me.Controller.TP.confirmDurationForVia,_me));
  Hafas.ps.sub('/tp/closeConfirmViaExceededPopover', Hafas.bind(_me.Controller.TP.closeConfirmViaExceededPopover,_me));
  Hafas.ps.sub('/tp/resetViaDuration', Hafas.bind(_me.Controller.TP.resetDurationForVia,_me));
  Hafas.ps.sub('/tp/clearViaSuggests', Hafas.bind(_me.Controller.TP.resetVias,_me));


  Hafas.ps.sub('/tp/requestError', Hafas.bind(function () {
    var button = Hafas('[name="submitTPForm"]');
    if (button) button.disabled = '';
  },_me));


  Hafas.ps.sub('/tp/checkVia/webapp', Hafas.bind(function (trigger, viaIndex) {
    if (trigger.value == "") {
      _me.Controller.TP.options.setRandomParameter("HFS_Via" + viaIndex, "value", "");
      _me.Controller.TP.instance.clearVia(viaIndex);
    }
  }, _me));

  // Via Bereich im Formular togglen
  Hafas.ps.sub('/tp/toggleViaForm', Hafas.bind(_me.Controller.TP.toggleViaFormContainer,_me));
  Hafas.ps.sub('/tp/showViaForm', Hafas.bind(_me.Controller.TP.showViaForm,_me));

  // Kontext-Menü für mehr Optionen anzeigen
  Hafas.ps.sub('/tp/viaShowMoreOptions', Hafas.bind(_me.Controller.TP.showMoreViaOptions,_me));
  // Haltedauer an Via ändern
  Hafas.ps.sub('/tp/changeViaLayoverDur', Hafas.bind(_me.Controller.TP.changeViaDuration,_me));
  // Haltedauer an Via entfernen
  Hafas.ps.sub('/tp/deleteViaLayoverDur', Hafas.bind(_me.Controller.TP.deleteViaDuration,_me));


  // Refresh Overview
  Hafas.ps.sub('/tp/overview/refresh', Hafas.bind(_me.Controller.TP.overview.refreshConnectionOverview, _me));
  Hafas.ps.sub('/tp/overview/clusterAllLoaded', Hafas.bind(_me.Controller.TP.overview.removeInfiniteLoader, _me));

  Hafas.ps.sub('/tp/details/expand', Hafas.bind(_me.Controller.TP.details.expandSection, _me));
  Hafas.ps.sub('/tp/details/refresh', Hafas.bind(_me.Controller.TP.details.refreshConnection, _me));

  Hafas.ps.sub('/tp/details/selectSection', Hafas.bind(_me.Controller.TP.details.selectSection, _me));
  Hafas.ps.sub('/tp/details/selectLocation', Hafas.bind(_me.Controller.TP.details.selectLocation, _me));

  // Teilsuche
  Hafas.ps.sub('/tp/details/openPartialSearchOverlay', Hafas.bind(_me.Controller.TP.details.openPartialSearchOverlay, _me));
  Hafas.ps.sub('/tp/details/cancelPartialSearchOverlay', Hafas.bind(_me.Controller.TP.details.cancelPartialSearchOverlay, _me));
  Hafas.ps.sub('/tp/details/confirmPartialSearchOverlay', Hafas.bind(_me.Controller.TP.details.confirmPartialSearchOverlay, _me));
  Hafas.ps.sub('/tp/details/partialSearchRequest',  Hafas.bind(_me.Controller.TP.details.partialSearchRequest, _me));
  Hafas.ps.sub('/tp/details/partialSearchEarlier',  Hafas.bind(_me.Controller.TP.details.partialSearchEarlier, _me));



  // Ergebnispanel vorbereiten und anzeigen
  Hafas.ps.sub('/tp/initGroupSearch/webapp', Hafas.bind(_me.Controller.TP.showResultOverview, _me));
  Hafas.ps.sub('/tp/updatedGroups/webapp', Hafas.bind(_me.Controller.TP.updateGroupResults, _me));
  Hafas.ps.sub('/tp/selectCluster/webapp', Hafas.bind(_me.Controller.TP.selectClusterGroup, _me.Controller.TP));
  Hafas.ps.sub('/tp/openSortList', Hafas.bind(_me.Controller.TP.openSortList, _me));
  Hafas.ps.sub('/tp/selectClusterSort', Hafas.bind(_me.Controller.TP.selectClusterSort, _me));
  Hafas.ps.sub('/tp/setClusterByGrpId', Hafas.bind(_me.Controller.TP.setClusterByGrpId, _me));

  // de-/aktivieren der automatischen clusterberechnung
  Hafas.ps.sub('/tp/toggleClusterAutoload/webapp', Hafas.bind(_me.Controller.TP.toggleClusterAutoload, _me.Controller.TP));
  Hafas.ps.sub('/tp/showMoreCluster/webapp', Hafas.bind(_me.Controller.TP.toggleClusterList, _me.Controller.TP));
  Hafas.ps.sub('/tp/toggleRealtimeSearch', Hafas.bind(_me.Controller.TP.toggleRealtimeSearch, _me.Controller.TP));
  Hafas.ps.sub('/tp/currentPositionActivated', Hafas.bind(_me.Controller.TP.toggleCurrentPosition, _me.Controller.TP));
  Hafas.ps.sub('/tp/toggleSubCluster', Hafas.bind(_me.Controller.TP.toggleSubCluster, _me));

  // TP Modul wird verlassen
  Hafas.ps.sub('/GUI/leaveContext/TP', Hafas.bind(_me.Controller.TP.cleanup, _me));

  // History Back
  Hafas.ps.sub('/GUI/closeView/TP', Hafas.bind(_me.Controller.TP.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/TP', Hafas.bind(_me.Controller.TP.restoreView, _me));

  Hafas.ps.sub('/tp/changeClusterSettings', Hafas.bind(_me.Controller.TP.changeClusterSettings, _me));

  // Via-Funktionen
  Hafas.ps.sub('/TP/options/init', Hafas.bind(_me.Controller.TP.via.init, _me));
  Hafas.ps.sub('/tp/options/via/remove', Hafas.bind(_me.Controller.TP.via.remove, _me));

  //Hafas.ps.sub('/app/events/closeResults', Hafas.bind(_me.Controller.Map.hideConnection,_me))

  Hafas.ps.sub('/app/events/closeResults', Hafas.bind(function (data) {
    if (data.resultSet == 'overview') {
      this.Controller.Map.hideConnection();
      this.Controller.Map.restoreTripMarker();
      // Geänderte Optionen im Formular anzeigen
      Hafas.ps.pub('/options/setChangedOptionsInputForm', [{context: 'TP'}]);
    } else if (data.resultSet == 'detail') {
      this.Controller.TP.details.hideDetailsMap(data);
      this.Controller.Map.showCurrentConnection();
    }
    Hafas.bind(this.Controller.TQ.hideResult, this)();
  }, _me));
  //
  // // TP select from DateTimePicker
  Hafas.ps.sub('/dateTimePicker/selectDateTime/TpOutDTP', Hafas.bind(_me.Controller.TP.selectDateTimeFromPicker, _me));
  //

  Hafas.ps.sub('/tp/searchReconstruction', Hafas.bind(_me.Controller.TP.searchReconstruction, _me));
  Hafas.ps.sub('/tp/reconstructionComplete', Hafas.bind(_me.Controller.TP.showReconstructedConnection, _me));

  Hafas.ps.sub('/tp/showDetailsMap', Hafas.bind(_me.Controller.TP.details.showDetailsMap, _me));
  Hafas.ps.sub('/tp/hideDetailsMap', Hafas.bind(_me.Controller.TP.details.hideDetailsMap, _me));

  Hafas.ps.sub('/tp/jumpToSQ', Hafas.bind(function (data) {
    var location = _me.Controller.TP.instance.getLocation(data);
    Hafas.ps.pub('/app/switchContext', [{context: "SQ"}]);
    _me.Controller.SQ.instance.setLocation(location);
    _me.Controller.SQ.instance.setBoardType(data);
    _me.Controller.SQ.instance.search();

  }, this));

  // Drag&Drop der Start/Ziel-Pins im Formular initialisieren
  Hafas.ps.sub('/app/events/renderDone', Hafas.bind(_me.Controller.TP.initDragDrop, _me));

  // Fahrradhöhenprofil
  Hafas.ps.sub('/tp/showElevationLevel', Hafas.bind(_me.Controller.TP.showElevationLevel, _me));
  Hafas.ps.sub('/tp/hideElevationLevel', Hafas.bind(_me.Controller.TP.hideElevationLevel, _me));
  Hafas.ps.sub('/tp/hideElevationIntroHint', Hafas.bind(_me.Controller.TP.hideElevationHint, _me));
  Hafas.ps.sub('/app/events/closeResults', Hafas.bind(_me.Controller.TP.hideElevationLevel, _me));
  Hafas.ps.sub('/app/events/closeResults', Hafas.bind(_me.Controller.TP.hideElevationHint, _me));
  Hafas.ps.sub('/tp/toggleDetails', Hafas.bind(_me.Controller.TP.toggleElevationLevel, _me))

  // Debug
  Hafas.ps.sub('/tp/printSearchLink', Hafas.bind(_me.Controller.TP.printSearchLink, _me));
  Hafas.ps.sub('/tp/printReconstructionLink', Hafas.bind(_me.Controller.TP.printReconstructionLink, _me));
  Hafas.ps.sub('/tp/printSelectedConnection', Hafas.bind(_me.Controller.TP.printSelectedConnection, _me));


  // GIS Route received -> Details neu rendern
  Hafas.ps.sub('/connection/gisRouteReceived/', Hafas.bind(_me.Controller.TP.details.refresh, _me));


  // clearTrip -> contextmenu
  Hafas.ps.sub('/tp/clearInput', Hafas.bind(_me.Controller.TP.clearInput, _me));

  // Tariff related
  Hafas.ps.sub('/tp/openTariffDetails', Hafas.bind(_me.Controller.TP.openTariffDetails, _me));
  Hafas.ps.sub('/tp/showTariffOverview', Hafas.bind(_me.Controller.TP.renderTariffOverview, _me));
  Hafas.ps.sub('/tp/updateTariffFilter', Hafas.bind(_me.Controller.TP.updateTariffOverview, _me));
  Hafas.ps.sub('/tp/refreshTariffOverview', Hafas.bind(_me.Controller.TP.refreshTariff, _me));

  if (Hafas.Config.TP.unifiedPlanner.show && Hafas.Config.TP.unifiedPlanner.requestOnChange) {
    Hafas.ps.sub('/tp/events/trigger/unified', Hafas.bind(function (params) {
      // console.log("+++ trigger search +++", params);
        Hafas.ps.pub('/tp/postForm', [{form: Hafas('#HFS_FormTripSearch')}]);
    }, this));
  }

  if (Hafas.Config.Switches.useEuSpirit) {
    Hafas.ps.sub('/tp/changeEUSpiritOption', Hafas.bind(_me.Controller.TP.changeEUSpiritOption, _me));
    Hafas.ps.sub('/tp/setLocation', Hafas.bind(_me.Controller.TP.setEuSpiritOption, _me));
    Hafas.ps.sub('/suggest/setProviderCtx/TP', Hafas.bind(function (prvId, suggestId) {
      Hafas.bind(_me.Controller.TP.changeEUSpiritOption,_me)({type:suggestId, value:prvId});
    }, _me));
  }

  Hafas.ps.sub('/suggest/setLocation', Hafas.bind(function (id, loc) {
    if (typeof id === 'string' && loc !== null && typeof loc === 'object') {
      if (id.startsWith('HFS_Via')) {
        // Validate passing parameters and check for vias
        var viaIndex = parseInt(id.charAt(7), 10);
        if (!isNaN(viaIndex)) {
          this.Controller.TP.setVia.bind(this)(viaIndex, loc);
          if (Hafas.Config.TP.vias.showInForm) {
            this.Controller.TP.showViaForm.bind(this)();
          }
        }
      } else if (id === 'From') {
        // Set departure location in instance
        this.Controller.TP.instance.setLocation("dep", loc);
      } else if (id === 'To') {
        // Set arrival location in instance
        this.Controller.TP.instance.setLocation("arr", loc);
      }
    }
  }, _me));

  Hafas.ps.sub('/suggest/setInputText', Hafas.bind(function (id, inputText) {
    // Validate passing parameters and check for vias
    if (typeof id === 'string' && typeof inputText === 'string' && id.startsWith('HFS_Via')) {
      var viaIndex = parseInt(id.charAt(7), 10);
      if (!isNaN(viaIndex) && inputText === '') {
        this.Controller.TP.removeVia.bind(this)(viaIndex);
      }
    }
  }, _me));

  Hafas.ps.sub('/tp/options/activateLocalStorage', Hafas.bind(_me.Controller.TP.setOptionStorageActive,_me));

  Hafas.ps.sub('options/save/TP', Hafas.bind(function (params) {
    _me.Controller.TP.optionsChanged = true;
    if (!Hafas.Config.TP.vias.showInForm) {
      Hafas.bind(_me.Controller.TP.updateStoredVias, _me)();
    }
  }, this));

};
